import { useQuery } from '@apollo/client';
import { useAuth0 } from '@auth0/auth0-react';
import { GET_USER_PERMISSIONS } from '../pages/users-managment/queries/roles';

export function usePermissions() {
  const { isAuthenticated, user, isLoading, error } = useAuth0();

  const {
    data,
    loading: roleLoading,
    error: roleError,
  } = useQuery(GET_USER_PERMISSIONS, {
    variables: {
      uuid: user?.sub,
      organizationUuid: user?.org_id,
    },
    skip: !isAuthenticated,
  });

  const userData = data?.getUserByUuid ?? {};

  return {
    userData,
    isLoading: isLoading || roleLoading,
    error: error || roleError,
  };
}
